/**
 * Formatting object generated by Goal app.
 *
 * @typedef {Object} Formatting
 * @namespace
 *
 * @memberof module:Goal.Model.Entity
 *
 * @property {String} decimalPlaces The numer of decimal places to output when rendering goal progress percentage.
 * @property {String} displayStatStrategy Strategy to indicate how we format participation stats (none|show current value|show value and target goal)
 */
class Formatting {

	constructor(decimalPlaces, displayStatStrategy) {

		this.decimalPlaces = decimalPlaces;
		this.displayStatStrategy = displayStatStrategy;
	}
}

export default Formatting;